(() => {
  const started = new WeakSet();
  function initEstimate(root) {
    if (started.has(root)) return;
    started.add(root);
    const quantity = root.querySelector('[data-pc-quantity]');
    const total = root.querySelector('[data-pc-total]');
    const unit = root.querySelector('[data-pc-unit]');
    const body = root.querySelector('[data-pc-body-price]');
    const print = root.querySelector('[data-pc-print-price]');
    const link = root.querySelector('[data-pc-product-link]');
    const bulk = root.querySelector('[data-pc-bulk]');
    const formatter = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: root.dataset.currency || 'JPY', maximumFractionDigits: 0 });
    const money = value => formatter.format(value / 100);
    function update() {
      const material = root.querySelector('[data-pc-material]')?.selectedOptions[0];
      const choices = [...root.querySelectorAll('input[name="pc-print"]:checked')];
      const count = Number(quantity.value);
      const basePrice = Number(material?.dataset.price);
      const extraPrice = choices.reduce((sum, input) => sum + Number(input.dataset.price), 0);
      const faces = choices.map(input => input.dataset.title?.normalize('NFKC').slice(0, 1)).filter(face => face === '表' || face === '裏');
      const valid = new Set(faces).size === faces.length && material && choices.length > 0 && Number.isInteger(count) && count >= 1 && count <= 999 && Number.isFinite(basePrice) && Number.isFinite(extraPrice);
      total.classList.toggle('is-invalid', !valid);
      bulk.hidden = !valid || count < 30;
      if (!valid) {
        total.textContent = root.dataset.invalidLabel;
        unit.textContent = '';
        body.textContent = '—';
        print.textContent = '—';
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        return;
      }
      total.textContent = money((basePrice + extraPrice) * count);
      unit.textContent = `${root.dataset.unitLabel} ${money(basePrice + extraPrice)}`;
      body.textContent = `${money(basePrice)} × ${count}`;
      print.textContent = `${money(extraPrice)} × ${count}`;
      const url = new URL(material.dataset.url, window.location.origin);
      url.searchParams.set('pc_qty', String(count));
      link.href = `${url.pathname}${url.search}`;
      link.removeAttribute('aria-disabled');
    }
    root.addEventListener('change', update);
    root.addEventListener('input', update);
    update();
  }
  function init() {
    document.querySelectorAll('[data-pc-estimator]').forEach(initEstimate);
    document.querySelectorAll('.pc-mobile-menu').forEach(menu => {
      if (started.has(menu)) return;
      started.add(menu);
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) menu.open = false;
      });
    });
    const requestedQuantity = Number(new URLSearchParams(window.location.search).get('pc_qty'));
    if (Number.isInteger(requestedQuantity) && requestedQuantity >= 1 && requestedQuantity <= 999) {
      const input = document.querySelector('product-info input.quantity__input[name="quantity"]');
      if (input && !input.dataset.pcPrefilled) {
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : 999;
        const step = Number(input.step) || 1;
        if (requestedQuantity >= min && requestedQuantity <= max && (requestedQuantity - min) % step === 0) {
          input.value = String(requestedQuantity);
          input.dataset.pcPrefilled = 'true';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
